import React from 'react'
import PropTypes from 'prop-types'

import { Typography, Divider } from '@mui/material'
import Grid from '@mui/material/Grid'

const DATE_COLUMN_WIDTH = 100
const AMOUNT_COLUMN_WIDTH = 120
const TOTAL_COLUMN_WIDTH = 120
const AMOUNT_APPLIED_COLUMN_WIDTH = 120

const ActivityHeader = ({
  dateLabel = 'Date',
  statusLabel = 'Status',
  totalLabel = 'Total',
  appliedLabel = 'Amount applied',
  showAppliedColumn = true,
}) => {
  return (
    <Grid container spacing={2.5} wrap="nowrap">
      <Grid minWidth={showAppliedColumn ? 100 : DATE_COLUMN_WIDTH} size="auto">
        <Typography variant="caption" fontWeight={700} color="text.secondary">
          {dateLabel}
        </Typography>
      </Grid>
      <Grid size="grow">
        <Typography variant="caption" fontWeight={700} color="text.secondary">
          {statusLabel}
        </Typography>
      </Grid>
      <Grid width={showAppliedColumn ? TOTAL_COLUMN_WIDTH : AMOUNT_COLUMN_WIDTH}>
        <Typography display="flex" alignItems="center" justifyContent="flex-end" variant="caption" fontWeight={700} color="text.secondary">
          {totalLabel}
        </Typography>
      </Grid>
      {showAppliedColumn && (
        <>
          <Grid display="flex" size="auto">
            <Divider flexItem orientation="vertical" />
          </Grid>
          <Grid width={AMOUNT_APPLIED_COLUMN_WIDTH}>
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              variant="caption"
              fontWeight={700}
              color="text.secondary"
            >
              {appliedLabel}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  )
}

ActivityHeader.propTypes = {
  dateLabel: PropTypes.string,
  statusLabel: PropTypes.string,
  totalLabel: PropTypes.string,
  appliedLabel: PropTypes.string,
  showAppliedColumn: PropTypes.bool,
}

export default ActivityHeader
